import { createSlice } from "@reduxjs/toolkit";


const authModelSlice = createSlice({
    name: 'model',
    initialState: {
        visible: '',
        data: {},
        mode: ''
    },
    reducers: {
        setVisible: (state, action) => {
            state.visible = action.payload
        },
        setData: (state, action) => {
            state.data = action.payload
        },
        setMode: (state, action) => {
            state.mode = action.payload
        }
    }
})

export const { setVisible, setData, setMode } = authModelSlice.actions;

export default authModelSlice.reducer